/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Environment Utils
 */

import { getTenantName } from './common';

class Environment {
	static LOCALHOST = 'localhost';
	static INTEGRATION = 'integration';
	static STAGING = 'staging';
	static PRODUCTION = 'production';
	private getTenantName: () => string;

	constructor(getTenantNameFunc = getTenantName) {
		this.getTenantName = getTenantNameFunc;
	}

	isLocalhost = () => {
		const hostname = globalThis.location.hostname;
		return hostname === Environment.LOCALHOST;
	};

	isIntegration = () => {
		const hostname = globalThis.location.hostname;
		return this.isLocalhost() || hostname.includes('veritable.work');
	};

	isStaging = () => {
		return this.getTenantName() === Environment.STAGING && this.isIntegration();
	};

	isProduction = () => {
		return !this.isIntegration();
	};

	getHostNames = (mode: 'integration' | 'production') => {
		const tenantName = this.getTenantName();
		const apexDomain = mode === 'integration' ? 'veritable.work' : 'veritable.app';
		const domain = `${tenantName}.${apexDomain}`;
		const clientURL = `https://${tenantName}.api.${apexDomain}`;
		// const authURL = `https://${domain}/auth`;
		const authURL = `https://auth.${apexDomain}/auth`;
		const posthogURL = `https://${domain}/_ph`;
		const accountsURL = `https://accounts.${apexDomain}`;
		return { clientURL, authURL, accountsURL, posthogURL };
	};

	getEnvironment = () => {
		return this.isIntegration() ? Environment.INTEGRATION : Environment.PRODUCTION;
	};

	getLoginHint = (): string | undefined => {
		if (!globalThis?.location) {
			return undefined;
		}

		const searchParams = new URLSearchParams(globalThis.location.search);
		return searchParams.get('login_hint');
	};
}

const env = new Environment();

export default env;
